var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Icon from '../../../icon';
import { ReceiptModalContext } from '../../context/ReceiptModalContext';
import { StyledReceiptTitle, StyledReceiptTitleCloseButton, StyledReceiptTitleWrapper, } from './styles/receipt-title.styled';
export const ReceiptTitle = (_a) => {
    var { children, dataTest = 'receipt-title' } = _a, props = __rest(_a, ["children", "dataTest"]);
    // Context could be null if the component is not rendered inside a ReceiptModalContextProvider
    const context = useContext(ReceiptModalContext);
    return (_jsxs(StyledReceiptTitleWrapper, { children: [_jsx(StyledReceiptTitle, Object.assign({ "data-test": dataTest }, props, { children: children })), context !== null && context.isOpen && (_jsx(StyledReceiptTitleCloseButton, { onClick: () => {
                    context.setIsOpen(false);
                }, children: _jsx(Icon, { variant: "cross", size: "sm" }) }))] }));
};
